<template>
	<my-dialog ref="editForm" :visible.sync="showDialog" title="出库单详情" dialog-type="form" :close-on-click-modal="false" width="80%" @close="closeDialog">
		<div v-loading="loading" class="main_bg" element-loading-text="加载中...">
			<div class="item_info border_Warningcolor">
				<el-descriptions class="margin-top" title="基本信息" :column="3" border>
					<el-descriptions-item label="出库单号">{{ editForm.outputStoreNo }}</el-descriptions-item>
					<el-descriptions-item label="出库时间">{{ editForm.outputDate }}</el-descriptions-item>

					<el-descriptions-item label="所属门店">{{ editForm.belongStoreName }}</el-descriptions-item>
					<el-descriptions-item label="顾客姓名">{{ transformEmpty(customerInfo.name) }}</el-descriptions-item>
					<el-descriptions-item label="性别">{{ transformGender(customerInfo.gender) }}</el-descriptions-item>
					<el-descriptions-item label="年龄">{{ transformEmpty(customerInfo.age) }}</el-descriptions-item>
					<el-descriptions-item label="顾客电话">{{ transformEmpty(customerInfo.phone) }}</el-descriptions-item>
					<el-descriptions-item label="下单日期">{{ transformEmpty(editForm.orderDate) }}</el-descriptions-item>

					<el-descriptions-item label="取镜日期">{{ transformEmpty(editForm.getOrderDate) }}</el-descriptions-item>

					<el-descriptions-item label="验光师">{{ transformEmpty(editForm.yanGuangShi) }}</el-descriptions-item>

					<el-descriptions-item label="加工类型">{{ transformEmpty(editForm.machinTypeStr) }}</el-descriptions-item>
					<el-descriptions-item label="出库状态">{{ editForm.outputStateStr }}</el-descriptions-item>

					<el-descriptions-item label="镜架信息" span="3">{{ transformEmpty(editForm.jjInformation) }}</el-descriptions-item>
					<el-descriptions-item label="备注" span="3">{{ transformEmpty(editForm.remark) }}</el-descriptions-item>
				</el-descriptions>
			</div>
			<div class="item_info border_Green">
				<div class="item_title">
					<div class="title">商品信息</div>
				</div>
				<el-table :cell-class-name="$moneyCellClass" :data="goodsTableData" style="width: 100%" border :header-cell-style="{ textAlign: 'center', borderColor: '#333' }" :cell-style="{ textAlign: 'center', borderColor: '#333' }">
					<el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
					<el-table-column prop="type" label="商品品牌" width="120"></el-table-column>
					<el-table-column prop="name" label="商品名称"></el-table-column>
					<el-table-column prop="qiuJing" label="球镜" width="80"></el-table-column>
					<el-table-column prop="zhuJing" label="柱镜" width="80"></el-table-column>
					<el-table-column prop="unit" label="单位" width="80"></el-table-column>
					<el-table-column v-if="isShowMoney" prop="price" label="单价" width="100"></el-table-column>
					<el-table-column prop="quantity" label="数量" width="155"></el-table-column>
					<el-table-column v-if="isShowMoney" prop="money" label="金额" width="100"></el-table-column>
					<el-table-column prop="remark" label="ADD"></el-table-column>
				</el-table>
			</div>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="closeDialog">关闭</el-button>
			</div>
		</template>
	</my-dialog>
</template>
<script>
import { GetOutputStoreDetail } from "@/api/receiptApi.js";

export default {
	props: [],
	data() {
		return {
			showDialog: false,
			saveloading: false,
			loading: false,
			editForm: {},
			goodsKeyIds: [],
			supplyList: [],
			customerInfo: {},
			goodsTableData: [],
			goodsIndex: 1,
			isShowMoney: false
		};
	},
	computed: {},
	watch: {},
	components: {},
	created() {},
	methods: {
		// 显示
		showDetailDialog(keyId) {
			this.editForm.keyId = keyId;
			this.showDialog = true;
			this.GetOutputStoreDetail();

			let userdata = JSON.parse(localStorage.getItem("userdata"));
			if (userdata.roleInfo.keyId == "2f91e757a9c4444dbe13146a363a717c") {
				this.isShowMoney = true;
			} else {
				this.isShowMoney = false;
			}
		},
		// 获取入库单详情
		GetOutputStoreDetail() {
			// 清空上一次的数据，显示加载中
			this.resetData();
			this.loading = true;
			this.saveloading = true;
			const params = {
				keyId: this.editForm.keyId
			};
			GetOutputStoreDetail(params)
				.then((res) => {
					this.saveloading = false;
					if (res.code == 1) {
						this.editForm = res.data;
						this.customerInfo = res.data.customerInfo;
						if (res.data.dtls != null && res.data.dtls.length > 0) {
							let rowNumber = 1;
							res.data.dtls.forEach((item) => {
								var info = {};
								info.rowNumber = rowNumber++;
								info.name = item.goodsInfo.name;
								info.type = item.goodsInfo.type;
								info.unit = item.goodsInfo.unit;
								info.qiuJing = item.goodsInfo.qiuJing;
								info.zhuJing = item.goodsInfo.zhuJing;
								info.goodsKeyId = item.goodsInfo.keyId;
								info.remark = item.remark;
								info.quantity = item.quantity;
								info.money = item.money;
								info.price = item.price;
								this.goodsTableData.push(info);
							});
						}
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.saveloading = false;
					this.$message.error("生成失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 重置展示数据（打开弹窗/切换数据时清空旧内容）
		resetData() {
			const keyId = this.editForm.keyId;
			this.editForm = { keyId: keyId };
			this.customerInfo = {};
			this.goodsTableData = [];
			this.goodsKeyIds = [];
			this.goodsIndex = 1;
		},
		// 关闭
		closeDialog() {
			this.$data.editForm = this.$options.data.call(this).editForm;
			this.goodsKeyIds = [];
			this.goodsIndex = 1;
			this.goodsTableData = [];
			this.showDialog = false;
		},
		// 性别
		transformGender(gender) {
			return gender == 1 ? "男" : gender == 0 ? "女" : "";
		},
		//判断为空则用 -- 替代
		transformEmpty(obj) {
			if (obj == "" || obj == null || obj == undefined) {
				obj = "--";
			}
			return obj;
		}
	}
};
</script>
<style scoped lang="scss">
.main_bg {
	padding: 10px;
	margin-top: -15px;
}

.item_info {
	border-left: 5px solid #55aaff;
	padding: 5px 10px;
	border-radius: 5px;
	margin-bottom: 15px;
	border-bottom: 2px solid #e9e7e7;
}

.border_Warningcolor {
	border-left: 5px solid #ff9900;
}

.border_Green {
	border-left: 5px solid #00cc66;
}

.item_title {
	display: flex;
	width: 100%;
	font-weight: 700;
	font-size: 1rem;
	margin-bottom: 10px;
	justify-content: space-between;

	.title {
		display: inline-block;
		unicode-bidi: isolate;
	}

	.btnDiv {
		display: block;
		unicode-bidi: isolate;
		word-break: break-all;
	}
}
</style>
